import { useTranslation } from "react-i18next";
import bg from '../../img/About/who_we.jpg';

const WhoWe = () => {
    const { t } = useTranslation();
    return (
        <section className="relative mt-[90px] md:mt-0 open-sans">
            <img className="absolute z-0 w-[100%] h-[100%] object-cover object-center inset-0" src={bg} alt='' />
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px] md:py-[100px] py-[50px]">
                <h2 className="text-[#fff] font-[700] text-[28px] xl:text-[45px]">
                    {t('about.who_we.title')}
                </h2>
                <div className="md:grid flex flex-col grid-cols-2 gap-[13px] md:gap-[40px] xl:gap-[95px] mt-[25px] md:mt-[30px] sm:text-[16px] text-[14px] text-[#fff] font-[300]">
                    <p>
                        {t('about.who_we.text_01')}
                    </p>
                    <div>
                        <p>
                            {t('about.who_we.text_02')}
                        </p>
                        <p className="mt-[13px] md:mt-[15px]">
                            {t('about.who_we.text_03')}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default WhoWe;
